<template>
    <div class="pricing-tables">
        <div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-5 col-md-6 col-sm-12 col-12">
                        <div class="card">
                            <div class="card-body text-center">
                                <h4 class="card-title text-uppercase">
                                    Basis
                                </h4>

                                <p class="description card-text text-center">
                                    Til dig, der vil bruge OP'N og de mange muligheder så længe du har lyst
                                </p>

                                <p class="price card-text">
                                    <span class="currency">DKK</span>
                                    <span class="amount">0</span>
                                    <span class="month text-muted">/ måned</span>
                                </p>

                                <router-link :to="{name: 'sign-up'}" class="btn btn-primary sign-up">
                                    Prøv OP'N nu
                                </router-link>
                            </div>

                            <div class="features card-body">
                                <ul>
                                    <li>Søgeordsovervågning</li>
                                    <li>Hjemmesidestatistik</li>
                                    <li>Tracking af anmeldelser</li>
                                    <li>Tracking af annoncer</li>
                                    <li>Opkobling til økonomisystem</li>
                                    <li>E-mail tracking</li>
                                    <li>
                                        <s>Opkaldstracking</s><br />
                                        <small><s>inkl. 100 minutters opkald</s></small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-5 col-md-6 col-sm-12 col-12">
                        <div class="card">
                            <div class="card-body text-center">
                                <h4 class="card-title text-uppercase">
                                    Business
                                </h4>

                                <p class="description card-text text-center">
                                    Til dig, der vil opnå fuld indsigt i kommunikationen med dine nye og eksisterende kunder
                                </p>

                                <p class="price card-text">
                                    <span class="currency">DKK</span>
                                    <span class="amount">199</span>
                                    <span class="month text-muted">/ måned</span>
                                </p>

                                <router-link :to="{name: 'sign-up'}" class="btn btn-primary sign-up">
                                    Prøv gratis i 30 dage
                                </router-link>
                            </div>

                            <div class="features card-body">
                                <ul>
                                    <li>Søgeordsovervågning</li>
                                    <li>Hjemmesidestatistik</li>
                                    <li>Tracking af anmeldelser</li>
                                    <li>Tracking af annoncer</li>
                                    <li>Opkobling til økonomisystem</li>
                                    <li>E-mail tracking</li>
                                    <li>
                                        Opkaldstracking<br />
                                        <small>inkl. 100 minutters opkald</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~bootstrap/scss/bootstrap.scss';

    .pricing-tables {
        position: relative;
        width: 100%;
        padding: 10vh 0;

        &:before {
            position: absolute;
            content: " ";
            background-color: #f7f7fb;
            z-index: 1;
            width: 100%;
            height: 60%;
            top: 40%;
            left: 0;
        }

        &:after {
            position: absolute;
            content: " ";
            background: url('/static/images/curve.svg');
            z-index: 1;
            width: 100%;
            height: 200px;
            background-size: cover;
            top: calc(40% - 200px);
            left: 0;
        }

        div {
            z-index: 2;

            .card {
                overflow: hidden;
                border-radius: 10px;
                box-shadow: 0 12px 40px rgba(0,0,0,0.10);

                border: 0;

                h4 {
                    font-size: 24px;
                    font-weight: 600;
                    margin-bottom: 20px;
                }

                .description {
                    font-size: 19px;
                    font-weight: 200;
                    max-width: 80vw;
                    margin: 30px auto;
                    min-height: 85px;
                }

                .price {
                    .currency {
                        font-size: 15px;
                        margin-right: 10px;
                    }

                    .amount {
                        font-size: 65px;
                    }
                }

                .sign-up {
                    padding: 10px 25px;
                    margin-top: 20px;
                }

                .card-body {
                    padding: 50px 20px;

                    &.features {
                        border-top: 1px solid #e4eaef;
                        background-color: #f7f8fc;

                        ul {
                            li {
                                color: #36434d;
                                font-size: 15px;
                                font-weight: 500;
                                padding: 7px 10px;

                                s {
                                    opacity: 0.6;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                show: 1,

                quotes: [
                    {
                        image: '/static/images/quotes/nis.png',
                        author: 'Nis Jensen',
                        employment: 'Digital Marketingschef hos Admiral Hotel',
                        description: "OP'N er blevet et redskab, vi bruger på lige fod med andre værktøjer i vores marketingafdeling til overblik og optimering af indsatser og processer"
                    },
                    {
                        image: '/static/images/quotes/nis.png',
                        author: 'Simon Salomonsson',
                        employment: "CEO hos OP'N Marketing ApS",
                        description: 'Hej med dig'
                    }
                ]
            }
        },

        computed: {
            total() {
                return this.quotes.length
            },

            quote() {
                return this.quotes[(this.show - 1)]
            }
        },

        methods: {
            next() {
                if (this.show ===  this.total) {
                    this.show = 1

                    return
                }

                this.show++
            },

            previous() {
                if (this.show === 1) {
                    this.show = this.total

                    return
                }

                this.show--
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/PricingTables.vue